import { Injectable, inject } from '@angular/core';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { NICmsContentComponent } from '@icms/core/content';
import { ICmsContentComponentValidationService } from '@icms/core/content/component/icms-content-component-validation.service';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NPwaAppInstallationModal } from './pwa-app-installation-modal.component';

@Injectable({ providedIn: 'root' })
export class PwaAppInstallationModalInitiatorService extends AbstractDfModalInitiatorService<void> {
    private iCmsBlockResource = inject(ICmsBlockResource);
    private timeoutService = inject(TimeoutService);
    private pwaIntegrationService = inject(PwaIntegrationService);
    private iCmsContentComponentValidationService = inject(ICmsContentComponentValidationService);

    listen(cb: () => void): Promise<void> {
        return new Promise(resolve => {
            // Open only on mobile sizes (S, M)
            if (!(this.app.client.isS || this.app.client.isM) || this.pwaIntegrationService.isStandalone) {
                resolve();
                return;
            }

            this.iCmsBlockResource
                .retrieve({ bareUrl: NPwaAppInstallationModal.MODAL_ID }, undefined)
                .then((block: ICmsBlock<NPwaAppInstallationModal.IBlockData> | void) => {
                    const canShow =
                        block &&
                        block.data?.content &&
                        !block.data.content.styles?.hidden &&
                        !this.iCmsContentComponentValidationService.getObjectHook(
                            block.data.content as unknown as NICmsContentComponent.IData
                        )?.state?.value;
                    if (canShow) {
                        const delaySec = Number(block.data!.content.delay || 0);
                        const delayMs = Number.isFinite(delaySec) ? Math.max(0, delaySec) * 1000 : 0;

                        if (delayMs > 0) {
                            this.timeoutService.setTimeout(() => cb(), delayMs);
                        } else {
                            cb();
                        }
                    } else {
                        resolve();
                    }
                })
                .catch(() => resolve());
        });
    }
}
